(function (root) {
  var $ = root.jQuery;
  if (!$) return;

  var FOCUSABLE = 'a[href], area[href], button, input, select, textarea, iframe, object, embed, [contenteditable], [tabindex]';
  var frame = null;

  function syncSlider(slider) {
    var $slider = $(slider);
    if (!$slider.length) return;

    $slider.find('.slick-slide').each(function () {
      var $slide = $(this);
      var inert = $slide.attr('aria-hidden') === 'true' || $slide.hasClass('slick-cloned');
      var $inner = $slide.find(FOCUSABLE);

      if (inert) {
        $slide.attr('tabindex', '-1');
        $inner.attr('tabindex', '-1');
        return;
      }

      $slide.removeAttr('tabindex');
      $inner.each(function () {
        if (this.getAttribute('tabindex') === '-1') this.removeAttribute('tabindex');
      });
    });

    $slider.find('.slick-list[aria-live]').attr('aria-live', 'off');
  }

  function syncAll() {
    $('.slick-initialized').each(function () {
      syncSlider(this);
    });
  }

  function schedule() {
    if (frame) root.cancelAnimationFrame(frame);
    frame = root.requestAnimationFrame(function () {
      frame = null;
      syncAll();
    });
  }

  function prefersReducedMotion() {
    return !!(root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function pauseAutoplay() {
    if (!prefersReducedMotion()) return;
    $('.slick-initialized').each(function () {
      try {
        $(this).slick('slickPause');
      } catch (e) {}
    });
  }

  function initAlertBarToggle() {
    var $btn = $('[data-alert-bar-toggle]');
    var $slider = $('.alert-bar__slider');
    if (!$btn.length || !$slider.hasClass('slick-initialized')) return;

    function setPaused(paused) {
      $btn.attr('data-paused', paused ? 'true' : 'false');
      $btn.attr('aria-label', paused ? 'Play announcements' : 'Pause announcements');
      try {
        $slider.slick(paused ? 'slickPause' : 'slickPlay');
      } catch (e) {}
    }

    $btn.on('click', function () {
      setPaused($btn.attr('data-paused') !== 'true');
    });

    setPaused(prefersReducedMotion());
  }

  $(function () {
    syncAll();
    pauseAutoplay();
    initAlertBarToggle();

    $(document).on('init reInit afterChange setPosition breakpoint', '.slick-slider', function () {
      schedule();
    });

    $(root).on('resize orientationchange', schedule);
  });
})(window);
